require('./bootstrap');

$(document).ready(function() {
  /* INCLUDE SVG */
  $('img[src$=".svg"]').each(function() {
    var $img = jQuery(this);
    var imgURL = $img.attr('src');
    var attributes = $img.prop("attributes");
    $.get(imgURL, function(data) {
        // Get the SVG tag, ignore the rest
        var $svg = jQuery(data).find('svg');
        // Remove any invalid XML tags
        $svg = $svg.removeAttr('xmlns:a');
        // Loop through IMG attributes and apply on SVG
        $.each(attributes, function() {
            $svg.attr(this.name, this.value);
        });
        // Replace IMG with SVG
        $img.replaceWith($svg);
    }, 'xml');
  });
  
  document.querySelectorAll('.grid').forEach(function(lg) {
    $('#' + lg.id).lightGallery({
      selector: 'a',
      download: false
    }); 
  })
   
});
 
AOS.init();

// SCROLLto  
function scrollTo(target) {
  var speed = 750; 
  var windowWidth = $(window).width();
  
  if(windowWidth > 995){
    $('html, body').animate( { scrollTop: $(target).offset().top - 90}, speed ); 
  }else{
    $('html, body').animate( { scrollTop: $(target).offset().top - 100}, speed ); 
  }
  
  return false;
  
}

$('.js-scrollTo').on('click', function(e) {
  e.preventDefault();
  
  var page = $(this).attr('href'); 
  var target = page.substr(page.indexOf('#'));
  
  if(document.querySelector(target) != null ) {
    scrollTo(target);
  }
  else {
    window.location = page + '?scroll=1';
  }
  
});

// ON LOAD, SCROLL TO ANCHOR IF SCOLL=1
window.addEventListener('load', function(e) {
 if(window.location.href.includes('?scroll=1')) {
  scrollTo(window.location.hash.substr(0, window.location.hash.indexOf('?')));
 }
});

// NavBar dropdown

  const $dropdown = $(".dropdown");
  const $dropdownToggle = $(".dropdown-toggle");
  const $dropdownMenu = $(".dropdown-menu");
  const showClass = "show"; 

  $(window).on("load resize", function() {
    if (this.matchMedia("(min-width: 992px)").matches) {
      $dropdown.hover(
        function() {
          const $this = $(this);
          $this.addClass(showClass);
          $this.find($dropdownToggle).attr("aria-expanded", "true");
          $this.find($dropdownMenu).addClass(showClass);
        },
        function() {
          const $this = $(this);
          $this.removeClass(showClass);
          $this.find($dropdownToggle).attr("aria-expanded", "false");
          $this.find($dropdownMenu).removeClass(showClass);
        }
      );
    } else {
      $dropdown.off("mouseenter mouseleave");
    }
  });

// BG nav scroll 
 $(window).scroll(function(){
  var posScroll = $(document).scrollTop();
    if(posScroll >=10) {
      $("nav").addClass("scrollnav");
    }
    else {
      $("nav").removeClass("scrollnav");
    }
});

// NavBarMobile
if(window.innerWidth < 992) {
  (function () {
    const navBarMobile = document.querySelector("nav");
    const icon = document.querySelector(".icon-container");
    
    icon.onclick = function () {
      navBarMobile.classList.toggle("menu-open");
      document.querySelector("body").classList.toggle("backdrop");
    };
  
  })();
}
else {}

// SET ACTIVE PANEL ON LOAD
function setActiveContent() {
  var hash = window.location.hash.substr(1);
  var navPills = document.getElementById('v-pills-tab');
  var navPanes = document.getElementById('v-pills-tabContent');
  
  if(navPills != undefined && navPanes != undefined) {
    // SET FIRST ELEMENT ACTIVE 
    if(hash == '') {
      $(navPills.children[0]).tab('show');
      
    }
    // OR VIA HASH
    else {
      $('#' + hash + '-link').tab('show');
      
    }
  }
  else {
    console.log('not found');
  }
  
}

setActiveContent();

// ACTIVE PANE ON CHANGE
window.onhashchange = setActiveContent;

// $('.grid').masonry({
//   // options
//   itemSelector: '.grid-item',
//   columnWidth: 200
// });

window.initMasonry = function() {
  var elem = document.querySelector('.grid');
  
  if(elem != null) {
    var msnry = new Masonry( elem, {
      // options
      itemSelector: '.grid-item',
      columnWidth: '.grid-item',
      percentPosition: true,
      isFitWidth: true,
    });
  }
}
